/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

export function Code( { children }: { children: ReactNode } ): ReactNode {
	const { palette } = useTheme();

	return (
		<Typography
			component='code'
			fontSize='inherit'
			fontStyle='inherit'
			fontWeight='inherit'
			// https://qwtel.com/posts/software/the-monospaced-system-ui-css-font-stack/#the-monospaced-system-ui-css-font-stack
			// eslint-disable-next-line max-len
			fontFamily='ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono", "Roboto Mono", "Oxygen Mono", "Ubuntu Monospace", "Source Code Pro", "Fira Mono", "Droid Sans Mono", "Courier New", monospace'
			color='inherit'
			bgcolor={ palette.grey[ 300 ] }
			padding='.1em .25em'
			borderRadius='.25em'
		>
			{ children }
		</Typography>
	);
}
